import { Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { VenueQuery } from './__generated__/show_query'
import { PencilIcon, PhoneIcon, DocumentIcon, VariableIcon } from '@heroicons/react/24/solid'
import { Tabs } from '@/components/tabs'
import { Form as DetailsForm } from '@/components/venue/edit_form'
import { EditCustomField as CustomFieldForm } from '@/components/venue/edit_custom_field'
import { EditContacts as EditContactForm } from '@/components/venue/edit_contacts'
import { EditAttachments } from './edit_attachments'
import { EditDocuments } from './edit_documents'

type Venue = VenueQuery['venues']['nodes'][0]

interface Props {
  venue: Venue
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const EditDialog = ({ venue, open, setOpen }: Props) => {
  const tabs = [
    { name: 'Details', component: <DetailsForm id={venue.id} />, icon: PencilIcon },
    { name: 'Contacts', component: <EditContactForm venueId={venue.id} />, icon: PhoneIcon },
    { name: 'Custom Fields', component: <CustomFieldForm venueId={venue.id} />, icon: VariableIcon },
    { name: 'Attachments', component: <EditAttachments id={venue.id} />, icon: DocumentIcon },
    { name: 'Documents', component: <EditDocuments id={venue.id} />, icon: DocumentIcon },
  ]

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle><div>{ venue.name }</div></DialogTitle>
        <DialogBody>
          <Tabs tabs={tabs} />
        </DialogBody>
      </Dialog>
    </>
  )
}
